import styled from 'styled-components'
import LoaderHexagon from '@/components/LoaderHexagon'

const PreloaderBlock = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
  z-index: 100;
`

const Preloader = ({ isLoading }) => {
  if (!isLoading) return null

  return (
    <PreloaderBlock>
      <LoaderHexagon />
    </PreloaderBlock>
  )
}

export default Preloader
